import React, { useEffect, useState, useCallback } from 'react';
import { DataGrid } from '../../common/Components';
import MaterialTableCS from '../../common/ComponentesCS/MaterialTableCS';
import { ClientService } from '../../common/services';
import { useHistory } from 'react-router';
// import MaterialTableCSCustom from '../../common/ComponentesCS/MaterialTableCSCustom';
// import { ClientService } from '../../common/services/client.service';
import APP from '../../common/tools/AppRoutes';
import { useStylesGeneral } from '../../styles/StyleComponents';
import "../../styles/site.css";
import Filters from './components/Filters';
import TextTitleCS from '../../common/ComponentesCS/TextTitleCS';
import { Button } from '@material-ui/core';

const tableActionButtonStyle = {
    backgroundColor: '#1976d2',
    color: 'white',
    padding: '5px 10px',
    fontSize: '12px',
    textTransform: 'none'
};

const Home = () => {
    const classes = useStylesGeneral();
    const [clients, setClients] = useState([]);
    const [originalClients, setOriginalClients] = useState([]); // Datos originales sin filtrar
    const [loading, setLoading] = useState(true);
    const history = useHistory();

    // Configuración de columnas para la tabla
    const columns = [
        {
            field: 'cliente',
            title: 'ID Cliente',
        },
        {
            title: 'Nombre',
            field: 'nombre',
        },
        {
            title: 'Estatus',
            field: 'estatus',
        },
        {
            field: 'Ingresar',
            title: 'Ingresar',
            sorting: false,
            render: (rowData) => (
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                        history.push({
                            pathname: `${APP.HOME}/projects`,
                            state: { project: rowData }
                        });
                    }}
                    style={tableActionButtonStyle}
                >
                    Ingresar
                </Button>
            )
        }
    ];


    useEffect(() => {
        const fetchClients = async () => {
            try {
                setLoading(true);
                // Nota: Los parámetros type, login, pass deben ser configurados según tus necesidades
                const response = await ClientService.getClients();
                setOriginalClients(response); // Guardar datos originales
                setClients(response);
            } catch (error) {
                setOriginalClients([]);
                setClients([]);
            } finally {
                setLoading(false);
            }
        };

        fetchClients();
    }, []);

    // Función para aplicar filtros a los datos
    const applyFilters = useCallback((filters) => {
        let filteredData = [...originalClients];

        // Filtrar por ID Cliente
        if (filters.clienteId && filters.clienteId.trim() !== '') {
            filteredData = filteredData.filter(client =>
                client.cliente && client.cliente.toLowerCase().includes(filters.clienteId.toLowerCase())
            );
        }

        // Filtrar por Nombre Cliente
        if (filters.nombreCliente && filters.nombreCliente.trim() !== '') {
            filteredData = filteredData.filter(client =>
                client.nombre && client.nombre.toLowerCase().includes(filters.nombreCliente.toLowerCase())
            );
        }

        // Filtrar por Estatus
        if (filters.estatus && filters.estatus.trim() !== '') {
            filteredData = filteredData.filter(client =>
                client.estatus && client.estatus.toLowerCase().includes(filters.estatus.toLowerCase())
            );
        }

        // Filtrar por fecha si tienes campos de fecha en tus datos
        // Puedes agregar lógica de fecha aquí si es necesario

        setClients(filteredData);
    }, [originalClients]);

    // Función para limpiar filtros
    const clearFilters = useCallback(() => {
        setClients(originalClients);
    }, [originalClients]);

    // En el componente padre
    const handleFiltersChange = useCallback((newFilters) => {
        applyFilters(newFilters);
    }, [applyFilters]);

    return (
        <div className={`${classes.root}`} style={{ display: 'flex', flexDirection: 'column', height: '100%', padding: '20px' }}>
            {/* <label className='tituloSeccion' style={{ alignSelf: 'flex-start' }}>Lista de Clientes</label> */}
            <TextTitleCS title="LISTA DE CLIENTES" />

            <Filters
                onFiltersChange={handleFiltersChange}
                onClearFilters={clearFilters}
            />
            <MaterialTableCS
                data={clients}
                columns={columns}
                title="Lista de Clientes"
                pageSize={10}
                showTitle={false}
                selection={false}
                actions={[]}
                pageSizeOptions={[5, 10, 25, 50]}
                toolbar={false}
                search={true}
                paging={true}
                loading={loading}

            />
        </div>
    );
};

export default Home;
